import { render, staticRenderFns } from "./AppAsideBarMovil.vue?vue&type=template&id=44463839&scoped=true"
import script from "./AppAsideBarMovil.vue?vue&type=script&lang=js"
export * from "./AppAsideBarMovil.vue?vue&type=script&lang=js"
import style0 from "./AppAsideBarMovil.vue?vue&type=style&index=0&id=44463839&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44463839",
  null
  
)

export default component.exports